import React from "react";
import client from "../assets/client.jpg";
import carga from "../assets/chat.png";
import utube from "../assets/video.jpg";
import { Link, useNavigate } from "react-router-dom";

const Speciality = () => {
  const navigate = useNavigate();

  return (
    <div className="canvas mt-10">
      <div className="d-flex justify-content-between">
        <div>
          <h1 className="fw-bold">Ven a Transferven</h1>
          <p className="mt-2 font2">
            En Transferven queremos ofrecerte las mayores ventajas. Seas Particular o Mayorista, tenemos siempre las mejores opciones para ti.
          </p>
        </div>
      </div>

      <div
        className="d-flex justify-content-between 
      align-items-center flex-wrap mt-4 gap-md-0 gap-3"
      >
        <div className="special-card rounded mt-3">
          <div
            className="d-flex align-items-center special-card 
        rounded text-white px-4 py-5 w-100"
            style={{ background: `url(${utube})` }}
          >
            <div>
              <p className="fw-bold fs-5">¿Cómo Funciona?</p>
              <p className="fs-5">Videos Explicativos</p>
              <Link
                to={"https://www.youtube.com/@Transferveneuropa"}
                target="_blank"
                className="px-5 btn text-white mt-4 special_btn rounded-pill"
                style={{ border: "1.99px solid white" }}
              >
                Ver
              </Link>
            </div>
          </div>
        </div>
        <div
          className="d-flex align-items-center special-card 
        rounded text-white px-4 py-5 mt-3"
          style={{ background: `url(${carga})` }}
        >
          <div>
            <p className="fw-bold fs-5">Atención Personalizada</p>
            <p className="fs-5">Servicio Web 24 Hrs.</p>
            <a href="https://wa.me/34620818181?text=¡Hola!" target="_blank"
              className="px-3 btn text-white mt-4 special_btn rounded-pill"
              style={{ border: "1.99px solid white", textDecoration: "none" }}
            >
              Chat Online
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Speciality;
